import { render } from "./ProxyManagement.vue?vue&type=template&id=08a1a0ba"
import script from "./ProxyManagement.vue?vue&type=script&lang=js"
export * from "./ProxyManagement.vue?vue&type=script&lang=js"

import "./ProxyManagement.vue?vue&type=style&index=0&id=08a1a0ba&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__